// middleware/03.module.global.ts
//
// Bloquea rutas declaradas en specialty_modules.guarded_routes cuando el módulo
// no está activo para la clínica actual. Permite paths con :param y wildcard *.

import { useClinicModulesStore } from '~/stores/clinic_modules'

function pathMatchesGuard(path: string, guard: string): boolean {
  // Convierte '/patients/:id/embarazo/*' a regex.
  const escaped = guard
    .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:[a-zA-Z_]+/g, '[^/]+')
    .replace(/\*/g, '.*')
  const re = new RegExp(`^${escaped}$`)
  return re.test(path)
}

export default defineNuxtRouteMiddleware((to) => {
  const modules = useClinicModulesStore()
  if (!modules.catalog.length) return // Catálogo aún no cargó (auth en curso). Permitir.

  for (const mod of modules.catalog) {
    const guarded = mod.guarded_routes ?? []
    for (const g of guarded) {
      if (pathMatchesGuard(to.path, g) && !modules.hasModule(mod.key)) {
        return navigateTo('/dashboard')
      }
    }
  }
})
